import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

interface IProps {
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class ErrorMessage extends React.Component<IProps> {
  render() {
    if (!this.show) return null;

    return (
      <h5 className="error-message">
        The attachments for this case have not correctly loaded. Please try again later.
      </h5>
    );
  }

  @computed
  get show() {
    let { status } = this.props.clinicalStore.prontoStore;
    return status === 'rejected';
  }
}

export default ErrorMessage;
